import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRInputAutocomplete } from 'src/app/models/qr-input-autocomplete.model';
import { QRInput } from 'src/app/models/qr-input.model';
import { TableHeader } from 'src/app/models/tableheader.model';
import { PanelService } from 'src/app/services/panel.service';

export interface CustomFilters {
  name: number | null;
  region: number | null;
  version: number | null;
  state: number | null;
}

@Component({
  selector: 'app-dialog-offices',
  templateUrl: './dialog-offices.component.html',
  styleUrls: ['./dialog-offices.component.scss'],
})
export class DialogOfficesComponent implements OnInit {
  //--------------------Inputs & Outputs--------------------
  @Input() value: any;
  @Output() change: EventEmitter<string> = new EventEmitter<string>();

  //--------------------Variables--------------------
  statesData: any = [];
  offices: { id: number; name: string; visible: boolean }[] = [];
  showUsersTable: boolean = false;
  userDisplayName: string = '-';
  isLoading: boolean = true;
  loggedUserSubscription: Subscription | undefined;
  sortingValue: string = '';
  sortingOrder: string = '';
  selectedOffices: number[] = [];
  allSelected: boolean = false;

  //--------------------Arrays & Objects--------------------
  selectedOffice = {
    declineDate: Date,
    hireDate: Date,
    id: Number,
    idFrames: Number,
    idListing: Number,
    idOffice: Number,
    name: String,
    oldMovements: String,
    oldMovementsId: String,
    region: String,
    regionName: String,
    remax_office_id: Number,
    rendMovements: String,
    rendMovementsId: Number,
    sign_date: Date,
    state: Number,
    stateId: Number,
    stateName: String,
    subRegion: Number,
    version: String,
    versionId: Number,
  };
  regionData: {
    id: number;
    region: string;
    year: string;
  }[] = [];
  customFilters: CustomFilters = {
    name: null,
    region: null,
    version: null,
    state: null,
  };
  officesFull: any = [];

  //--------------------Dropdowns--------------------
  officeDropdownConfig: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Oficinas',
    isCleanButtonVisible: true,
    options: [],
  };
  regionDropdownConfig: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    mode: QRInput.MODE_STRING,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Regiones',
    isCleanButtonVisible: true,
    options: [],
  };
  versionDropdownConfig: QRInputAutocomplete = {
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    mode: QRInput.MODE_STRING,
    placeholder: 'Versiones',
    isCleanButtonVisible: true,
    options: [],
  };

  //--------------------Buttons--------------------
  cleanFiltersConfig: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Limpiar Filtros',
  };
  selectAllConfig: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Seleccionar Todo',
  };

  //--------------------Tables--------------------
  statsTableHeader: TableHeader[] = [
    {
      id: 'name',
      text: 'Nombre',
      percentageWidth: 20,
      isOrderByVisible: true,
    },
    {
      id: 'region',
      text: 'Region',
      percentageWidth: 20,
      isOrderByVisible: true,
    },
    {
      id: 'version',
      text: 'Version',
      percentageWidth: 20,
      isOrderByVisible: true,
    },
    {
      id: '',
      text: '',
      percentageWidth: 20,
      isOrderByVisible: false,
    },
  ];

  constructor(private readonly panelService: PanelService) {}

  ngOnInit(): void {
    this.getAllOffices();
    this.loadOffices();
    this.loadRegionDropdown();
  }
  loadOffices() {
    this.offices = [];
    this.panelService.getAdvancedSearchOffices().then(
      (res: any) => {
        this.offices = res.data;

        for (let i = 1; i < this.offices.length; i++) {
          this.officeDropdownConfig.options.push(this.offices[i].name);
        }
      },
      (error: Error) => {
        console.log(error);
      }
    );
  }
  loadRegionDropdown() {
    this.regionData = [];
    this.panelService.getAdvancedSearchRegions().then(
      (res: any) => {
        this.regionData = res.data;

        this.regionData.forEach((e: any) =>
          this.regionDropdownConfig.options.push(e.region)
        );
      },
      (error: Error) => {
        console.log(error);
      }
    );
  }

  //--------------------Dropdowns Change && Clean-Filters Button
  dropdownChangeOffice(event: string | undefined) {
    if (event) {
      const matchingOffice = this.offices.find(
        (office: { name: any }) => office.name == event
      );

      if (matchingOffice) {
        //check if the office selected is the one called '-' (like nothing in the dropdown)
        if (this.customFilters) {
          this.customFilters.name =
            matchingOffice.id != 561 ? matchingOffice.id : null;
        }
      }
    } else if (this.customFilters) {
      this.customFilters.name = null;
    }
    this.getAllOffices();
  }

  dropdownChangeRegion(event: any) {
    let regionAux = this.regionData.find(
      (e: { region: string }) => e.region == event
    );

    if (this.customFilters && regionAux) {
      this.customFilters.region = regionAux.id ?? null;
    }

    this.getAllOffices();
  }

  dropdownChangeVersion(event: any) {
    this.getAllOffices();
  }

  dropdownChangeState(event: any) {
    this.officesFull = [];

    if (event != undefined) {
      let state = this.statesData.find((e: { label: any }) => e.label == event);
      if (state) {
        state = state.id;
        this.customFilters.state = state;
      }
    } else {
      this.customFilters.state = null;
    }

    this.getAllOffices();
  }
  sortBy(event: any) {
    if (event?.column) {
      this.sortingValue = event.column;
      this.sortingOrder = event.orientation;
    }
  }

  //--------------------Advanced Search--------------------

  getAllOffices() {
    let region = null;
    let version = null;
    let name = null;
    if (this.customFilters) {
      region = this.customFilters.region;
      version = this.customFilters.version;
      name = this.customFilters.name;
    }

    this.panelService.postAdvancedSearch(region, name, version).then(
      (res: any) => {
        if (res?.data) {
          this.officesFull = [];
          const FILTERED_RESULTS = res.data;
          for (const ELEMENT of FILTERED_RESULTS) {
            const AUX = {
              name: ELEMENT.name,
              region: ELEMENT.regionName,
              state: ELEMENT.stateId,
              version: ELEMENT.version,
              sign_date: ELEMENT.hireDate,
              remax_office_id: ELEMENT.idOffice,
              declineDate: ELEMENT.declineDate,
              hireDate: ELEMENT.hireDate,
              id: ELEMENT.agencyId,
              idFrames: ELEMENT.idFrames,
              idListing: ELEMENT.idOffice,
              idOffice: ELEMENT.idOffice,
              oldMovements: ELEMENT.oldMovements,
              oldMovementsId: ELEMENT.oldMovementsId,
              regionName: ELEMENT.regionName,
              rendMovements: ELEMENT.rendMovements,
              rendMovementsId: ELEMENT.rendMovementsId,
              stateId: ELEMENT.stateId,
              stateName: ELEMENT.stateName,
              subRegion: ELEMENT.subRegionId,
              versionId: ELEMENT.versionId,
            };
            this.officesFull.push(AUX);
          }
        }
      },
      (error: Error) => {
        console.log(error);
      }
    );
  }
  cleanFilters() {
    this.officeDropdownConfig.value = 'clear';
    this.regionDropdownConfig.value = 'clear';
    this.versionDropdownConfig.value = 'clear';

    this.officeDropdownConfig = { ...this.officeDropdownConfig };
    this.regionDropdownConfig = { ...this.regionDropdownConfig };
    this.versionDropdownConfig = { ...this.versionDropdownConfig };
  }
  checkedOfficesFunction(event: any) {
    this.change.emit(event);
  }
  selectAll() {
    this.selectAllConfig.viewValue = this.allSelected
      ? 'Seleccionar Todo'
      : 'Deseleccionar Todo';
    this.allSelected = !this.allSelected;
  }
}
